import React, { useEffect, useState } from 'react';
import { IS_DEMO, IS_LAXMI_HOST } from '../../utils/demo';
import { bannerText } from '../../utils/subscriptionBanner';

// Renewal reminder for an operator's admin. The gateway answers /subscription.json only on the shared
// address and the operators' subdomains; Laxmi's own hosts and the demo never ask.
export default function SubscriptionBanner() {
  const [text, setText] = useState('');
  useEffect(() => {
    if (IS_DEMO || IS_LAXMI_HOST) return;
    fetch('/subscription.json', { cache: 'no-store' })
      .then(r => (r.ok ? r.json() : null))
      .then(s => setText(bannerText(s)))
      .catch(() => {});
  }, []);
  if (!text) return null;
  return (
    <div role="alert" style={{ background: '#fef3c7', color: '#92400e', border: '1px solid #fcd34d', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: '.85rem', fontWeight: 600 }}>
      {text}
    </div>
  );
}
